import type { OutcomeSummaryData } from '../../../../../../types/page';

const OutcomeSummary = ({ componentName }: OutcomeSummaryData) => {
    return (
        <div className="formatted-outcome-summary" data-testid="formatted-outcome-summary">
            <span className="summary-keyword">TRIGGER</span> the outcome bound to{' '}
            <span className="summary-name">&quot;{componentName || 'UNKNOWN'}&quot;</span>
        </div>
    );
};

export default OutcomeSummary;
